import React, { useContext } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Box,
  Avatar,
  Divider,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import useApiEp from "../../../hooks/useApiEp";
import { UserContext } from "../../context/UserContext";

const NotificationsWidget = () => {
  const { user, loading } = useContext(UserContext);
  const { data: notifications, isLoading } = useApiEp(
    `/user/get-my-notifications`
  );

  if (isLoading) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">Loading notifications...</Typography>
      </Box>
    );
  }

  if (!notifications || notifications.length === 0) {
    return (
      <Box sx={{ py: 6, textAlign: "center" }}>
        <NotificationsOffOutlinedIcon
          sx={{ fontSize: 48, color: "#cbd5e1", mb: 1 }}
        />
        <Typography variant="body1" color="#64748b" fontWeight={600}>
          No new notifications
        </Typography>
      </Box>
    );
  }

  return (
    <List sx={{ p: 0 }}>
      {notifications.slice(0, 10).map((notification, index) => (
        <React.Fragment key={notification.id}>
          <ListItem
            component={"a"}
            href={
              notification.type === "chat"
                ? `/${user?.role}/my-chats`
                : `/${user?.role}/meetings`
            }
            sx={{
              textDecoration: "none",
              px: 2,
              py: 1.5,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "#f0f9ff",
                cursor: "pointer",
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Avatar
                sx={{
                  bgcolor: "#e0f2fe",
                  color: "#0369a1",
                  width: 32,
                  height: 32,
                }}
              >
                {notification.type === "chat" ? (
                  <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
                ) : notification.type === "meeting" ? (
                  <EventAvailableIcon sx={{ fontSize: 16 }} />
                ) : (
                  <NotificationsIcon sx={{ fontSize: 16 }} />
                )}
              </Avatar>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  variant="body2"
                  fontWeight={600}
                  color="#334155"
                  sx={{ lineHeight: 1.3, mb: 0.5 }}
                >
                  {notification.message}
                </Typography>
              }
              secondary={
                <Typography variant="caption" color="#94a3b8" fontWeight={500}>
                  {new Date(notification.createdOn).toLocaleString(undefined, {
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Typography>
              }
            />
          </ListItem>
          {index < notifications.slice(0, 10).length - 1 && (
            <Divider sx={{ borderColor: "#f1f5f9" }} />
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default NotificationsWidget;
